
import LoadingComp from './loading-instance'
import Toast from 'vant/es/toast/index'
import 'vant/es/toast/index.css'
let instance = null

const getInstance = () => {
  if (instance) {
    return instance
  }

  const Ctor = Vue.extend(LoadingComp)
  const vnode = new Ctor({})
  instance = vnode.$mount()
  const el = instance.$el
  document.body.appendChild(el)
  return instance
}

export default {
  data() {
    return {
      loadingInstance: instance,
      toast: Toast
    }
  },
  created() {
    this.loadingInstance = getInstance()
  },
  mounted() {
  },
  methods: {
    showLoading() {
      this.loadingInstance.show()
    },
    hideLoading() {
      this.loadingInstance.hide()
    }
  }
}
